import ServiceBase from './../../ServiceBase';
import alertCommonProxy from '../../../proxies/tools/alerts/AlertSystemProxy';
import alertProxy from '../../../proxies/tools/alerts/AlertProxy';

export class AlertService extends ServiceBase {
  getAlertChartImage(params) {
    return this.applyMemoryCache(
      'AlertSystemService.getAlertChartImage',
      params,
    )(() => alertCommonProxy.getAlertChartImage(params));
  }
  getAllSystemAlerts(params) {
    return this.applyMemoryCache(
      'AlertSystemService.GetAllSystemAlerts',
      params,
    )(() => alertProxy.getAllSystemAlerts(params));
  }

  subscribeSystemAlert(params) {
    return alertProxy.subscribeSystemAlert(params);
  }

  getNotificationList(params) {
    return this.applyMemoryCache(
      'AlertSystemService.getNotificationList',
      params,
    )(() => alertProxy.getNotificationList(params));
  }
  getPersonalAlertTypes(params) {
    return this.applyMemoryCache(
      'AlertSystemService.getPersonalAlertTypes',
      params,
    )(() => alertProxy.getPersonalAlertTypes(params));
  }

  getPersonalSubsribedAlerts(params) {
    return alertProxy.getPersonalSubsribedAlerts(params).then(res => {
      return res ? res.data : {};
    });
  }

  addPersonalAlert(params) {
    return alertProxy.addPersonalAlert(params);
  }

  editPersonalAlert(params) {
    return alertProxy.editPersonalAlert(params);
  }

  activePersonalAlert(params) {
    return alertProxy.activePersonalAlert(params);
  }

  removePersonalAlert(params) {
    return alertProxy.removePersonalAlert(params);
  }
}
const alertService = new AlertService();
export default alertService;
